import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import IndexPage from 'flarum/forum/components/IndexPage';
import Link from 'flarum/common/components/Link';
import LinkButton from 'flarum/common/components/LinkButton';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import CommentPost from 'flarum/forum/components/CommentPost';
import BrandMark from './components/BrandMark';
import HomeLayout from './components/HomeLayout';
import ServerPage from './components/ServerPage';
import RankingPage from './components/RankingPage';
import NovaIdPage from './components/NovaIdPage';
import TeamPage from './components/TeamPage';
import RulesPage from './components/RulesPage';
import DiscordResultPage from './components/DiscordResultPage';
import { PremiumPage, PenaltiesPage, VehiclesPage, VehiclePage } from './components/PortalPages';
import { GlobalPortalShell, HoverPreview } from './components/GlobalPortalShell';
import ThreadEnhancements from './components/ThreadEnhancements';
import UserRoleBadge from './components/UserRoleBadge';
import CourtPage from './components/CourtPage';
import { ContactPage, PrivacyPage } from './components/InfoPages';
const external = url => /^https?:\/\//i.test(url);
const installFavicon = () => {
  const base = window.location.origin;
  let favicon = document.querySelector('link[rel="icon"]');
  if (!favicon) {
    favicon = document.createElement('link');
    favicon.rel = 'icon';
    document.head.appendChild(favicon);
  }
  favicon.type = 'image/svg+xml';
  favicon.href = `${base}/assets/extensions/novatruck-theme/favicon.svg?v=137`;
};
app.initializers.add('novatruck-theme', () => {
  installFavicon();
  app.routes['novatruck.server'] = {
    path: '/serwer',
    component: ServerPage
  };
  app.routes['novatruck.ranking'] = {
    path: '/ranking',
    component: RankingPage
  };
  app.routes['novatruck.novaid'] = {
    path: '/novaid',
    component: NovaIdPage
  };
  app.routes['novatruck.discord-linked'] = {
    path: '/novaid/discord/polaczono',
    component: DiscordResultPage
  };
  app.routes['novatruck.discord-error'] = {
    path: '/novaid/discord/blad',
    component: DiscordResultPage
  };
  app.routes['novatruck.team'] = {
    path: '/ekipa',
    component: TeamPage
  };
  app.routes['novatruck.rules'] = {
    path: '/regulamin',
    component: RulesPage
  };
  app.routes['novatruck.premium'] = {
    path: '/premium',
    component: PremiumPage
  };
  app.routes['novatruck.vehicles'] = {
    path: '/pojazdy',
    component: VehiclesPage
  };
  app.routes['novatruck.vehicle'] = {
    path: '/pojazdy/:id',
    component: VehiclePage
  };
  app.routes['novatruck.penalties'] = {
    path: '/kary',
    component: PenaltiesPage
  };
  app.routes['novatruck.court'] = {
    path: '/sad',
    component: CourtPage
  };
  app.routes['novatruck.court.case'] = {
    path: '/sad/:id',
    component: CourtPage
  };
  app.routes['novatruck.contact'] = {
    path: '/kontakt',
    component: ContactPage
  };
  app.routes['novatruck.privacy'] = {
    path: '/polityka-prywatnosci',
    component: PrivacyPage
  };
  extend(HeaderPrimary.prototype, 'items', items => {
    const currentPath = String(m.route.get() || '/').split('?')[0];
    const active = currentPath.startsWith('/serwer') ? 'nt-server' : currentPath.startsWith('/ranking') ? 'nt-ranking' : currentPath.startsWith('/ekipa') ? 'nt-team' : currentPath.startsWith('/regulamin') ? 'nt-rules' : 'nt-forum';
    const navClass = key => `NtHeaderLink ${active === key ? 'is-active' : ''}`;
    items.add('nt-brand', m(Link, {
      className: "NtHeaderBrand",
      href: app.route('index')
    }, m(BrandMark, null), m("strong", null, "NovaTruck & RP")), 1000);
    items.add('nt-forum', m(Link, {
      className: navClass('nt-forum'),
      href: app.route('index')
    }, "FORUM"), 900);
    const nav = [['nt-server', 'SERWER', app.route('novatruck.server')], ['nt-ranking', 'RANKING', app.route('novatruck.ranking')], ['nt-team', 'EKIPA', app.route('novatruck.team')], ['nt-rules', 'REGULAMIN', app.route('novatruck.rules')]];
    nav.forEach((_ref, index) => {
      let [key, label, href] = _ref;
      const url = String(href);
      items.add(String(key), external(url) ? m("a", {
        className: navClass(String(key)),
        href: url
      }, label) : m(Link, {
        className: navClass(String(key)),
        href: url
      }, label), 890 - index);
    });
  });
  extend(HeaderSecondary.prototype, 'items', items => {
    const links = [['nt-drawer-forum', 'fas fa-comments', 'Forum', '/'], ['nt-drawer-server', 'fas fa-server', 'Serwer', '/serwer'], ['nt-drawer-ranking', 'fas fa-trophy', 'Ranking', '/ranking'], ['nt-drawer-team', 'fas fa-users', 'Ekipa', '/ekipa'], ['nt-drawer-rules', 'fas fa-file-alt', 'Regulamin', '/regulamin'], ['nt-drawer-novaid', 'fas fa-id-card', 'NovaID', '/novaid'], ['nt-drawer-premium', 'fas fa-gem', 'Premium', '/premium'], ['nt-drawer-vehicles', 'fas fa-car', 'Pojazdy', '/pojazdy'], ['nt-drawer-penalties', 'fas fa-gavel', 'Kary', '/kary'], ['nt-drawer-court', 'fas fa-balance-scale', 'Sąd', '/sad'], ['nt-drawer-contact', 'fas fa-envelope', 'Kontakt', '/kontakt']];
    links.forEach((_ref2, index) => {
      let [key, symbol, label, href] = _ref2;
      return items.add(key, m(LinkButton, {
        className: "NtDrawerLink",
        icon: symbol,
        href: href
      }, label), 1900 - index);
    });
  });
  override(IndexPage.prototype, 'view', function () {
    return m(HomeLayout, null);
  });
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const user = this.attrs?.post?.user?.();
    const post = this.attrs?.post;
    if (user) items.add('nova-role', m(UserRoleBadge, {
      userId: Number(user.id()),
      postId: Number(post?.id?.() || 0)
    }), 65);
  });
  extend(DiscussionPage.prototype, 'oncreate', function () {
    const id = Number(this.discussion?.id?.() || 0);
    const hero = document.querySelector('.DiscussionPage .DiscussionHero');
    if (!id || !hero || document.getElementById('NtThreadEnhancements')) return;
    const root = document.createElement('div');
    root.id = 'NtThreadEnhancements';
    root.className = 'container';
    hero.insertAdjacentElement('afterend', root);
    m.mount(root, {
      view: () => m(ThreadEnhancements, {
        discussionId: id
      })
    });
  });
  window.setTimeout(() => {
    if (!document.getElementById('NtGlobalPortalShell')) {
      const root = document.createElement('div');
      root.id = 'NtGlobalPortalShell';
      document.querySelector('.App-header')?.insertAdjacentElement('afterend', root);
      m.mount(root, GlobalPortalShell);
    }
    if (!document.getElementById('NtHoverPreviewRoot')) {
      const root = document.createElement('div');
      root.id = 'NtHoverPreviewRoot';
      document.body.appendChild(root);
      m.mount(root, HoverPreview);
    }
  }, 0);
});